
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Route } from 'vue-router';
import DateRange from '@/components/DateRange.vue';
import api from '@/api';
import Util from '@/utils/util';
import Swal from 'sweetalert2';

const { otherPoint } = api;

@Component({
  components: { DateRange },
})
export default class OtherPointActivityList extends Vue {
  @Prop() private id!: string;

  private pointName = '';

  private data = { data: [], totalCount: 0, pageSize: 8, pageNo: 0 };

  private loading = false;

  private panel = 0;

  private get totalCount() {
    return this.data.totalCount;
  }

  private get pageCount() {
    return Math.ceil((this.data.totalCount || 0) / (this.data.pageSize || 8));
  }

  private get collection() {
    return [...(this.data.data || [])];
  }

  private filter = {
    startStartOn: this.$route.query.startStartOn
      ? this.$route.query.startStartOn
      : '',
    endStartOn: this.$route.query.endStartOn ? this.$route.query.endStartOn : '',
    startEndOn: this.$route.query.startEndOn
      ? this.$route.query.startEndOn
      : '',
    endEndOn: this.$route.query.endEndOn ? this.$route.query.endEndOn : '',
    q: this.$route.query.q ? this.$route.query.q : '',
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 8
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
  };

  private async handleOpenDelete(activityId: any) {
    await Swal.fire(
      {
        title: '您確定要刪除嗎?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
      },
    ).then(async (result) => {
      if (result.isConfirmed) {
        const { status } = await otherPoint.activityDelete(this.id, activityId);
        if (status === 1) {
          await Swal.fire({ icon: 'success', title: '刪除成功' });
          this.requestData();
        } else {
          await Swal.fire({ icon: 'warning', title: '刪除失敗，請聯繫系統管理員。' });
        }
      }
    });
  }

  private async openLink(link: string) {
    if (link) {
      window.open(link, '_blank');
    } else {
      await Swal.fire({ icon: 'warning', title: '活動連結未設定。' });
    }
  }

  private async updatePage(page: number) {
    this.filter.pageNo = page;
    await this.query();
  }

  private async search() {
    this.filter.pageNo = 1;
    await this.query();
  }

  private async query() {
    const query = {
      ...this.filter,
      pageSize: `${this.filter.pageSize}`,
      pageNo: `${this.filter.pageNo}`,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    }
    await this.requestData();
  }

  private async reset() {
    this.filter = {
      q: '',
      startStartOn: '',
      endStartOn: '',
      startEndOn: '',
      endEndOn: '',
      pageSize: 8,
      pageNo: 1,
    };
    await this.query();
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private async requestData() {
    this.loading = true;
    const { data: { pointName } } = await otherPoint.get(this.id);
    this.pointName = pointName;
    const { data } = await otherPoint.activityList(this.id, this.filter);
    this.data = data;
    this.loading = false;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: OtherPointActivityList) => void) | boolean) => void,
  ) {
    const { id, name } = to.params;
    await next(async (vm) => {
      await vm.requestData();
    });
  }
}
